export const sortByNumber = (a: number, b: number) : number => {
  if (a < b) return -1
  if (a > b) return 1
  return 0
}

export const sortByString = (a: string | null, b: string | null) : number => {
  if ((a == null ? '' : a.toUpperCase()) < (b == null ? '' : b.toUpperCase())) return -1
  if ((a == null ? '' : a.toUpperCase()) > (b == null ? '' : b.toUpperCase())) return 1
  return 0
}

export const sortByDate = (a: string | null, b: string | null) : number => {
  if ((a == null ? '' : a) < (b == null ? '' : b)) return -1
  if ((a == null ? '' : a) > (b == null ? '' : b)) return 1
  return 0
}
